import { RectangleStackIcon } from '@heroicons/react/24/outline';
import { Badge } from '@oysterjs/ui/badge';

/** Marks a bulk email: one bulk draft for many clients rather than one email. */
export const BulkBadge = () => (
  <Badge color="neutral" className="shrink-0">
    <RectangleStackIcon className="size-3.5" aria-hidden />
    Bulk
  </Badge>
);
